import React from 'react';
import './HeaderLineTabs.css';

export const LAYOUT_HEADER = 'header';
export const LAYOUT_LINE = 'line';

export function readLayoutView(storageKey) {
    try {
        return sessionStorage.getItem(storageKey) === LAYOUT_LINE ? LAYOUT_LINE : LAYOUT_HEADER;
    } catch (e) {
        return LAYOUT_HEADER;
    }
}

export function saveLayoutView(storageKey, value) {
    try {
        sessionStorage.setItem(storageKey, value === LAYOUT_LINE ? LAYOUT_LINE : LAYOUT_HEADER);
    } catch (e) { /* ignore storage errors */ }
}

const HeaderLineTabs = ({ value, onChange }) => {
    const current = value === LAYOUT_LINE ? LAYOUT_LINE : LAYOUT_HEADER;
    return (
        <div className="header-line-tabs" role="tablist" aria-label="Order layout">
            <button
                type="button"
                role="tab"
                aria-selected={current === LAYOUT_HEADER}
                className={`header-line-tab${current === LAYOUT_HEADER ? ' is-active' : ''}`}
                onClick={() => onChange(LAYOUT_HEADER)}
            >
                Header
            </button>
            <button
                type="button"
                role="tab"
                aria-selected={current === LAYOUT_LINE}
                className={`header-line-tab${current === LAYOUT_LINE ? ' is-active' : ''}`}
                onClick={() => onChange(LAYOUT_LINE)}
            >
                Line
            </button>
        </div>
    );
};

export default HeaderLineTabs;
